<template>
  <v-menu v-model="openEditTag" :close-on-content-click="false" left>
    <template v-slot:activator="{ on }">
      <mf-button color="cinza-0" icon="edit" type="icon" size="sm" @click="openEditTag = true" />
    </template>
    <v-card>
      <v-container class="pa-4">
        <v-row>
          <v-col class="pt-0">
            <v-text-field ref="updateTagInput" v-model="tagName" outlined hide-details label="Nome do marcador" maxlength="30" @keyup.enter="updateTagName" />
          </v-col>
        </v-row>
        <v-row class="px-3">
          <mf-button label="Deletar" class="mr-2" text icon="delete" color="vermelho-d20" @click="deleteTag(tag)" />
          <v-spacer />
          <mf-button label="Salvar" @click="updateTagName" />
        </v-row>
      </v-container>
    </v-card>
  </v-menu>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'

export default {
  name: 'EditTag',
  props: {
    tag: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    tags: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    openEditTag: false,
    tagName: '',
    tagOldName: '',
  }),
  computed: {
    tagList() {
      return this.tags
    },
  },
  watch: {
    openEditTag(value) {
      if (!value) return
      this.tagName = this.tag.name
      this.tagOldName = this.tag.name
      setTimeout(() => {
        if (this.$refs.updateTagInput) {
          this.$refs.updateTagInput.$el.querySelector('input').select()
        }
      }, 200)
    },
  },
  methods: {
    deleteTag(tag) {
      this.openEditTag = false
      this.$emit('delete-tag', tag)
    },
    updateTagName() {
      if (!this.tagName) return
      this.openEditTag = false
      const tagList = cloneDeep(this.tagList)
      const index = tagList.findIndex((tag) => tag.name === this.tagOldName)
      if (index < 0) return
      this.$emit('update-tag', { ...tagList[index], name: this.tagName })
    },
  },
}
</script>
